import React from 'react';

import { useGetContinueWatching, useGetVODShowDetails } from '@hooks';

import { PictureDetailedVODContent } from '../PictureDetailedVODContent/PictureDetailedVODContent';

export const PictureDetailedVODContentAPI = ({ data }) => {
  const id = data.showID;
  const { data: showData } = useGetVODShowDetails(id);
  const { data: continueWatchingData } = useGetContinueWatching();

  let allShowData = showData;

  // Get up next
  let upNextShow = null;
  let previousDate = new Date(2015, 12, 31).getTime();

  if (showData) {
    // Get data array
    const continueWatching = continueWatchingData?.data ? continueWatchingData.data['continue-watching'] : [];

    // Reduce into map by id
    const continueWatchingMap = {};

    for (const continueWatchingItem of continueWatching) {
      continueWatchingMap[continueWatchingItem._id] = continueWatchingItem;
    }

    const watchedData = continueWatchingData?.data ? continueWatchingData.data['watch-again'] : [];

    const watchedDataMap = {};

    for (const watchedDataItem of watchedData) {
      watchedDataMap[watchedDataItem._id] = watchedDataItem;
    }

    // Update each episode with its continue watching point
    const seasonsWithContinueWatching = showData.seasons.map(season => {
      const episodesWithContinueWatching = season.episodes.map(episode => {
        const episodeData = continueWatchingMap[episode.id];
        const episodeWatched = watchedDataMap[episode.id];

        // Set data for partially watched episode
        if (episodeData) {
          const { point, progress, updatedAt } = episodeData;
          const episodeUpdatedAtTime = new Date(updatedAt).getTime();

          if (previousDate < episodeUpdatedAtTime) {
            previousDate = episodeUpdatedAtTime;
            upNextShow = { ...episode, point, progress, updatedAt };
          }
          return { ...episode, point, progress, updatedAt };
        }
        // Set data for completely watched episode
        else if (episodeWatched) {
          return { ...episode, watched: true };
        } else {
          return episode;
        }
      });

      return { ...season, episodes: episodesWithContinueWatching };
    });

    // Check the completed episodes to set an up next episode
    if (!upNextShow) {
      let foundEpisode = false;

      for (const [sIndex, season] of showData.seasons.entries()) {
        for (const [index, episode] of season.episodes.entries()) {
          const episodeWatched = watchedDataMap[episode.id];

          if (episodeWatched) {
            foundEpisode = true;
            if (index + 1 < season.episodes.length) {
              upNextShow = season.episodes[index + 1];
            } else if (sIndex + 1 < showData.seasons.length && showData.seasons[sIndex + 1].episodes.length > 0) {
              upNextShow = showData.seasons[sIndex + 1].episodes[0];
            }
          }
          if (foundEpisode) {
            break;
          }
        }
        if (foundEpisode) {
          break;
        }
      }
    }

    // Combine show data and updated episode data for continue watching
    allShowData = { ...showData, seasons: seasonsWithContinueWatching };
  }

  // Should always have a season, otherwise assume single season
  if (upNextShow && !upNextShow?.season) {
    if (showData?.seasons?.length === 1) {
      upNextShow.season = '1';
    } else {
      upNextShow = null;
    }
  }

  // If no episode, must be bad data. Do not set
  if (!upNextShow?.episode) {
    upNextShow = null;
  }

  // TODO: Loading and error states?

  return <PictureDetailedVODContent data={{ ...allShowData }} upNextShow={upNextShow} />;
};
